import { useEffect, useRef, useContext } from "react"
import ReactDOM from "react-dom"
import { computePosition, flip, shift } from "@floating-ui/react"
import { FilterMenuItem } from "../../flexible-table-items.interface"
import "./FilterMenu.css"
import Suggestion from "../header-suggetions/Suggestion"
import { FiltersContext } from "../../context/table.context"
import { usePortalLayer } from "src/shared/providers/PortalLayerProvider"

const FilterMenu = ({
    filters,
    onSelectFilter,
    fromHeader,
    onClose,
    anchorRef,
}: {
    filters: FilterMenuItem[]
    onSelectFilter?: (filter: string, fromHeader: string) => void
    fromHeader: string
    onClose: () => void
    anchorRef: React.RefObject<HTMLElement>
}) => {
    const { selectedFilters, setSelectedFilters } = useContext(FiltersContext)
    const portalLayer = usePortalLayer()
    const floatingRef = useRef<HTMLDivElement>(null)
    const selectedFiltersForThisHeader = selectedFilters?.filter((f) => f.fromHeader === fromHeader).length

    useEffect(() => {
        if (!anchorRef.current || !floatingRef.current) return
        computePosition(anchorRef.current, floatingRef.current, {
            placement: "bottom-start",
            middleware: [flip(), shift({ padding: 8 })],
        }).then(({ x, y }) => {
            if (floatingRef.current) {
                Object.assign(floatingRef.current.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                    visibility: "visible",
                })
            }
        })
    }, [anchorRef])

    const onClearFilters = () => {
        setSelectedFilters?.(f => f?.filter(filt => filt.fromHeader !== fromHeader))
        onClose()
    }

    return ReactDOM.createPortal(
        <div
            ref={floatingRef}
            className="flexible-table__filter-menu"
            style={{ visibility: "hidden", position: "absolute", top: 0, left: 0 }}
        >
            <div
                className="header-suggetions__item"
                style={{ pointerEvents: !selectedFilters?.length ? "none" : "auto" }}
                onClick={(e) => {
                    e.stopPropagation()
                    onClearFilters()
                }}
            >
                <span className="header-suggestions__item-clear">
                    Borrar filtro {selectedFiltersForThisHeader ? `(${selectedFiltersForThisHeader})` : ""}
                </span>
            </div>
            {filters.map((filter, index) => (
                <Suggestion
                    key={index}
                    onChange={() => onSelectFilter?.(filter.value, fromHeader)}
                    option={filter}
                    fromHeader={fromHeader}
                />
            ))}
        </div>,
        portalLayer
    )
}

export default FilterMenu
